<template>
  <Drawer v-model="drawerVisible" :width="width" title="预览" transfer :styles="{ padding: 0 }">
    <div class="form-view-preview-body">
      <BasePreview v-if="url" :url="url" :name="name" />
    </div>
  </Drawer>
</template>

<script>
export default {
  name: 'FormViewPreviewDrawer',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    url: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    width: {
      type: Number,
      default: 960,
    },
  },
  computed: {
    drawerVisible: {
      get() {
        return this.visible;
      },
      set(v) {
        this.$emit('update:visible', v);
      },
    },
  },
};
</script>

<style lang="less" scoped>
.form-view-preview-body {
  height: calc(100vh - 110px);
  overflow: hidden;
}
</style>
